module.exports = __webpack_public_path__ + "static/media/StarWhiteOutline.6e257270.svg";